import { styled } from '@mui/material/styles';

export const DescriptionContainer = styled('div')`
  padding: 8px 8px;
  background-color: ${({ theme }) => theme.palette.grey['02']};
  border-radius: 8px;
  z-index: 3000;
  border: ${({ theme }) => `1px solid ${theme.palette.grey['01']}`};
  max-width: 320px;
`;

export const NoContentContainer = styled('div')`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 24px;
  color: red;
`;

export const TitleContainer = styled('div')`
  display: flex;
  flex-direction: row;
  text-align: left;
  gap: 24px;
  align-items: center;
`;
